import React, { useState } from 'react';
import Modal from 'react-bootstrap/Modal';

const SearchButton = () => {
    const [show, setShow] = useState(false);

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);
    return (
        <>
            <li>
                <button
                    type="button"
                    className="main-menu__search search-toggler icon-search"
                    aria-label="Open search"
                    onClick={handleShow}
                />
            </li>
            <div className="search-popup">
                <Modal show={show} onHide={handleClose} className="search-popup__overlay search-toggler">
                <div className="search-popup__content">
                    <form action="#">
                        <label htmlFor="search" className="sr-only">search here</label>
                        <input type="text" id="search" placeholder="Search Here..." />
                        <button type="submit" aria-label="search submit" className="thm-btn2">
                            <i className="fa fa-search" aria-hidden="true"></i>
                        </button>
                    </form>
                </div>
                </Modal>
            </div>
        </>     
    )
}

export default SearchButton;